import { render } from "./FilterKabupaten.vue?vue&type=template&id=5ee36daf"
import script from "./FilterKabupaten.vue?vue&type=script&lang=js"
export * from "./FilterKabupaten.vue?vue&type=script&lang=js"
script.render = render

export default script